var map = {
	"./Clubs1.png": 92,
	"./Clubs10.png": 93,
	"./Clubs10_neon.png": 94,
	"./Clubs1_neon.png": 95,
	"./Clubs2.png": 96,
	"./Clubs2_neon.png": 97,
	"./Clubs3.png": 98,
	"./Clubs3_neon.png": 99,
	"./Clubs4.png": 100,
	"./Clubs4_neon.png": 101,
	"./Clubs5.png": 102,
	"./Clubs5_neon.png": 103,
	"./Clubs6.png": 104,
	"./Clubs6_neon.png": 105,
	"./Clubs7.png": 106,
	"./Clubs7_neon.png": 107,
	"./Clubs8.png": 108,
	"./Clubs8_neon.png": 109,
	"./Clubs9.png": 110,
	"./Clubs9_neon.png": 111,
	"./ClubsA.png": 112,
	"./ClubsA_neon.png": 113,
	"./ClubsJ.png": 114,
	"./ClubsJ_neon.png": 115,
	"./ClubsK.png": 116,
	"./ClubsK_neon.png": 117,
	"./ClubsQ.png": 118,
	"./ClubsQ_neon.png": 119,
	"./Diamonds1.png": 120,
	"./Diamonds10.png": 121,
	"./Diamonds10_neon.png": 122,
	"./Diamonds1_neon.png": 123,
	"./Diamonds2.png": 124,
	"./Diamonds2_neon.png": 125,
	"./Diamonds3.png": 126,
	"./Diamonds3_neon.png": 127,
	"./Diamonds4.png": 128,
	"./Diamonds4_neon.png": 129,
	"./Diamonds5.png": 130,
	"./Diamonds5_neon.png": 131,
	"./Diamonds6.png": 132,
	"./Diamonds6_neon.png": 133,
	"./Diamonds7.png": 134,
	"./Diamonds7_neon.png": 135,
	"./Diamonds8.png": 136,
	"./Diamonds8_neon.png": 137,
	"./Diamonds9.png": 138,
	"./Diamonds9_neon.png": 139,
	"./DiamondsA.png": 140,
	"./DiamondsA_neon.png": 141,
	"./DiamondsJ.png": 142,
	"./DiamondsJ_neon.png": 143,
	"./DiamondsK.png": 144,
	"./DiamondsK_neon.png": 145,
	"./DiamondsQ.png": 146,
	"./DiamondsQ_neon.png": 147,
	"./Hearts1.png": 148,
	"./Hearts10.png": 149,
	"./Hearts10_neon.png": 150,
	"./Hearts1_neon.png": 151,
	"./Hearts2.png": 152,
	"./Hearts2_neon.png": 153,
	"./Hearts3.png": 154,
	"./Hearts3_neon.png": 155,
	"./Hearts4.png": 156,
	"./Hearts4_neon.png": 157,
	"./Hearts5.png": 158,
	"./Hearts5_neon.png": 159,
	"./Hearts6.png": 160,
	"./Hearts6_neon.png": 161,
	"./Hearts7.png": 162,
	"./Hearts7_neon.png": 163,
	"./Hearts8.png": 164,
	"./Hearts8_neon.png": 165,
	"./Hearts9.png": 166,
	"./Hearts9_neon.png": 167,
	"./HeartsA.png": 168,
	"./HeartsA_neon.png": 169,
	"./HeartsJ.png": 170,
	"./HeartsJ_neon.png": 171,
	"./HeartsK.png": 172,
	"./HeartsK_neon.png": 173,
	"./HeartsQ.png": 174,
	"./HeartsQ_neon.png": 175,
	"./Spades1.png": 176,
	"./Spades10.png": 177,
	"./Spades10_neon.png": 178,
	"./Spades1_neon.png": 179,
	"./Spades2.png": 180,
	"./Spades2_neon.png": 181,
	"./Spades3.png": 182,
	"./Spades3_neon.png": 183,
	"./Spades4.png": 184,
	"./Spades4_neon.png": 185,
	"./Spades5.png": 186,
	"./Spades5_neon.png": 187,
	"./Spades6.png": 188,
	"./Spades6_neon.png": 189,
	"./Spades7.png": 190,
	"./Spades7_neon.png": 191,
	"./Spades8.png": 192,
	"./Spades8_neon.png": 193,
	"./Spades9.png": 194,
	"./Spades9_neon.png": 195,
	"./SpadesA.png": 196,
	"./SpadesA_neon.png": 197,
	"./SpadesJ.png": 198,
	"./SpadesJ_neon.png": 199,
	"./SpadesK.png": 200,
	"./SpadesK_neon.png": 201,
	"./SpadesQ.png": 202,
	"./SpadesQ_neon.png": 203,
	"./card_back.png": 44,
	"./card_back_neon.png": 45,
	"./joker-64.png": 204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;